import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { FAIcon } from '../adapters/fontAwesomeAdapters';
import { useBackButtonStyles } from './BackButton.styles';

export default function BackButton({ onClick, className }) {
  const { styles } = useBackButtonStyles();

  return (
    <div
      type="button"
      className={classNames(styles.backButton, className)}
      onClick={onClick}
    >
      <FAIcon icon="arrow-circle-left" />
      <span className={styles.backButtonLabel}>
        <FormattedMessage id="buttons.back" />
      </span>
    </div>
  );
}
